export default "__VITE_ASSET__DgQqq3oT__"